import React, { useCallback, useMemo } from 'react'
import DownloadsNavButton from '../../components/Navigation/DownloadsNavButton'
import { useSelector } from 'react-redux'
import { useCheckBox, useSelect } from '@chilecompra/react-kit'
import { Button, Select, CheckBox } from '@chilecompra/react-kit/components'
import { getMonthOptions } from '../../modules/utils/months'
import { generateYears } from '../../modules/utils/years'
import { REACT_APP_DLPP_URL } from '../../config/settings/environment'
import {
  Description,
  GridContainer,
  GridItem,
  Root,
  Subtitle,
  Title
} from './DownloadLargePurchaseProcessesSection.styles'

/**
 * The DownloadLargePurchaseProcessesSection's container.
 */
const DownloadLargePurchaseProcessesSection = () => {
  const { endYear } = useSelector(state => state.topNavbar)
  const { value: yearValue, onChange: handleChangeYear } = useSelect({
    initialValue: endYear,
    overwriteCallback: () => endYear
  })
  const { value: monthValue, onChange: handleChangeMonth } = useSelect({ initialValue: '01' })
  const yearsOptions = useMemo(() => generateYears(endYear), [endYear])
  const monthOptions = useMemo(() => getMonthOptions(), [])
  const { value: checked, onChange: handleChangeCheck } = useCheckBox()

  const handleClickDownload = useCallback(() => {
    const Value = checked ? yearValue : `${yearValue}_${monthOptions.find(item => item.value === monthValue).name}`
    const anchorElement = document.createElement('a')
    anchorElement.setAttribute('download', Value)
    anchorElement.setAttribute('href', `${REACT_APP_DLPP_URL}/${yearValue}/Procesos_de_Gran_Compra_${Value}.zip`)
    anchorElement.setAttribute('target', '_blank')
    anchorElement.click()
  }, [monthValue, yearValue, checked])

  const mdValue = useMemo(() => {
    if (checked) return 5
    return 2
  }, [checked])
  return (
    <Root>
      <GridContainer padding="0 0 26px">
        <DownloadsNavButton />
        <GridItem xs={10} sm={11}>
          <Title> Procesos de Gran Compra</Title>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 30px">
        <GridItem xs={12}>
          <Description>
            En esta sección, podrás acceder a información detallada sobre los procesos de Grandes Compras realizados en
            Mercado Público. Nuestro objetivo es proporcionar datos completos y transparentes que faciliten el análisis
            y la gestión eficiente de estos procesos.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 26px">
        <GridItem xs={12}>
          <Subtitle>¿Qué encontrarás aquí?</Subtitle>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 30px">
        <GridItem xs={12}>
          <Description>
            Información completa descargable en formato CSV que incluye todos los detalles asociados a los procesos de
            Grandes Compras.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 26px">
        <GridItem xs={12}>
          <Subtitle>¿Cómo utilizar esta sección?</Subtitle>
        </GridItem>
      </GridContainer>
      <GridContainer padding="0 0 30px">
        <GridItem xs={12}>
          <Description>
            Utiliza los filtros y descarga los reportes de Procesos de Gran Compra. Puedes descargar filtrando mes por
            año o también descargar todos los meses disponibles en el año seleccionado.
          </Description>
        </GridItem>
      </GridContainer>
      <GridContainer alignItems="center" padding="0" spacing={1}>
        <GridItem xs={12} md={mdValue}>
          <Select label="AÑO" options={yearsOptions} value={yearValue} onChange={handleChangeYear} />
        </GridItem>
        {!checked && (
          <GridItem xs={12} md={3}>
            <Select label="MES" options={monthOptions} value={monthValue} onChange={handleChangeMonth} />
          </GridItem>
        )}
        <GridItem xs={12} md={3}>
          <CheckBox checked={checked} label="Todos los meses" onChange={handleChangeCheck} />
        </GridItem>
        <GridItem xs={12} md={4}>
          <Button color="primary" onClick={handleClickDownload}>
            Descargar archivo
          </Button>
        </GridItem>
      </GridContainer>
    </Root>
  )
}

export default DownloadLargePurchaseProcessesSection
